import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { Markdown } from '../components/Markdown/Markdown';
import { resolvePrivacyContent } from '../content/legal/resolveLegalContent';

export const Route = createFileRoute('/privacy')({
  component: PrivacyPage,
});

function PrivacyPage() {
  const { i18n, t } = useTranslation('legal');
  const privacyContent = resolvePrivacyContent(i18n.language);

  return (
    <div className="pageContainer">
      <h1 className="pageTitle">{t('privacyTitle')}</h1>
      <div className="pageSection">
        <Markdown content={privacyContent} />
      </div>
    </div>
  );
}
